import { AppAction } from "../types";
import { SessionState } from "../types/SessionState";

/** All the session action types. */
export enum ActionKey {
  SET_SESSION_STATE = "SET_SESSION_STATE",
  SET_USER_PHONE_VERIFIED = "SET_USER_PHONE_VERIFIED",
}

/** An action that sets the session state collectively. */
export interface SetSessionStateAction
  extends AppAction<ActionKey.SET_SESSION_STATE, { session: SessionState }> {}

/** An action that sets the user's phone verified status */
export interface SetUserPhoneVerifiedAction
  extends AppAction<
    ActionKey.SET_USER_PHONE_VERIFIED,
    { isVerified: boolean }
  > {}

/** All the session actions. */
export type SessionAction = SetSessionStateAction | SetUserPhoneVerifiedAction;

/** Sets the session state. */
export const createSetSessionStateAction = (
  session: SessionState
): SetSessionStateAction => ({
  type: ActionKey.SET_SESSION_STATE,
  payload: { session },
});

/** Sets the phone verified status */
export const createSetUserPhoneVerifiedAction = (isVerified: boolean) => ({
  type: ActionKey.SET_USER_PHONE_VERIFIED,
  payload: { isVerified },
});
